import React, { useState } from 'react'
import styles from './styles.module.scss'

import { FieldGroup, FormCard } from '../../reusable'
import { FormPartInterface } from '../../../interfaces'
import { useClaimData } from '../../../claimProvider'

export const OpenBankingLink = (props: FormPartInterface) => {
    const { isActive } = props
    const [linkCopied, setLinkCopied] = useState(false)
    const [currentStep, setCurrentStep] = useState(0)

    const claimData = useClaimData()

    const handleCopyLink = async () => {
        if (claimData.openBankingUrl) {
            try {
                await navigator.clipboard.writeText(claimData.openBankingUrl)
                setLinkCopied(true)
                setTimeout(() => setLinkCopied(false), 2000)
            } catch (err) {
                console.error('Failed to copy link:', err)
            }
        }
    }

    const getCurrentStep = () => {
        return isActive === 'openBankingLink' ? (
            <>
                <FieldGroup title="Connect Your Bank Account">
                    <FormCard step={currentStep} assignPostStep={setCurrentStep}>
                        <div className={styles.openBankingContainer}>
                            <div className={styles.header}>
                                <h3 className={styles.title}>Final Step: Connect Open Banking</h3>
                                <p className={styles.description}>
                                    To complete your application we need to analyse your lending, we do this through
                                    bank statement analysis. Please connect your open banking now.
                                </p>
                            </div>

                            <div className={styles.ctaSection}>
                                {claimData.openBankingUrl ? (
                                    <>
                                        <a
                                            href={claimData.openBankingUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={styles.ctaButton}
                                        >
                                            <span className={styles.buttonIcon}>🔗</span>
                                            Connect Open Banking
                                        </a>

                                        <div className={styles.linkFallback}>
                                            <p className={styles.fallbackText}>
                                                If the button doesn't work, copy and paste this link:
                                            </p>
                                            <div className={styles.linkContainer}>
                                                <input
                                                    type="text"
                                                    value={claimData.openBankingUrl}
                                                    readOnly
                                                    className={styles.linkInput}
                                                />
                                                <button onClick={handleCopyLink} className={styles.copyButton}>
                                                    {linkCopied ? '✓ Copied!' : 'Copy Link'}
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className={styles.errorContainer}>
                                        <p className={styles.error}>
                                            Banking link not available. Please try again later.
                                        </p>
                                    </div>
                                )}
                            </div>

                            <div className={styles.analysisSection}>
                                <h4 className={styles.analysisTitle}>Why We Need Bank Statement Analysis</h4>
                                <div className={styles.analysisGrid}>
                                    <div className={styles.analysisItem}>
                                        <div className={styles.analysisIcon}>🔍</div>
                                        <h5 className={styles.analysisItemTitle}>Prove Provider Negligence</h5>
                                        <p className={styles.analysisDescription}>
                                            We analyze your bank statements to demonstrate how lenders failed to
                                            properly check your eligibility and affordability before providing loans.
                                        </p>
                                    </div>
                                    <div className={styles.analysisItem}>
                                        <div className={styles.analysisIcon}>⚡</div>
                                        <h5 className={styles.analysisItemTitle}>Fast & Secure Review</h5>
                                        <p className={styles.analysisDescription}>
                                            Open Banking provides the fastest and most secure way to review your lending
                                            history, with bank-grade encryption protecting your data throughout the
                                            process.
                                        </p>
                                    </div>
                                    <div className={styles.analysisItem}>
                                        <div className={styles.analysisIcon}>🎯</div>
                                        <h5 className={styles.analysisItemTitle}>Unbiased Analysis</h5>
                                        <p className={styles.analysisDescription}>
                                            Our fully autonomous technology analyzes raw banking data to provide an
                                            objective assessment of your lending situation without human bias.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.benefitsSection}>
                                <h4 className={styles.benefitsTitle}>Is My Information Safe</h4>
                                <ul className={styles.benefitsList}>
                                    <li className={styles.benefitItem}>
                                        <span className={styles.checkmark}>✓</span>
                                        <span>We use bank-level security encryption</span>
                                    </li>
                                    <li className={styles.benefitItem}>
                                        <span className={styles.checkmark}>✓</span>
                                        <span>Its read-only access - we cannot make any changes to your account</span>
                                    </li>
                                    <li className={styles.benefitItem}>
                                        <span className={styles.checkmark}>✓</span>
                                        <span>We only access information relevant to your claim</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </FormCard>
                </FieldGroup>
            </>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
